<template>
  <div class="file-man">
    <div class="contain">
      {{ bookInfo.bookName }}
      <el-button class="fr" type="primary" size="small" @click="toBack"
        >返回</el-button
      >
    </div>
    <div class="module">对应模块：{{ bookInfo.integralModelDesc }}</div>
    <div class="list">
      <div
        v-for="(paragraph, index) in bookInfo.paragraphList"
        :key="paragraph.id"
        class="list-item"
      >
        <div class="title">{{ index + 1 }}、{{ paragraph.paraTitle }}</div>
        <div class="attach">
          <div v-for="item in paragraph.paraAttaches" :key="item.url">
            <img
              v-if="item.type.includes('image')"
              style="height: 180px"
              :src="item.url"
              @click="showImg(item.url, paragraph.paraAttaches)"
            />
            <a
              v-if="item.type.includes('video')"
              :href="item.url"
              target="_blank"
              style="height: 180px"
            >
              <video controls style="width: 100%; height: 100%">
                <source :src="item.url" type="video/mp4" />
              </video>
            </a>
          </div>
        </div>
        <div class="content">
          操作说明&emsp;&emsp;{{ paragraph.paraContent }}
        </div>
      </div>
      <!-- 图片预览弹框 -->
      <ViewImg :img-path-list="imgPathList" :is-show.sync="imgVisible" />
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import ViewImg from "@/components/ViewImg.vue";
export default {
  components: {
    ViewImg,
  },
  data() {
    return {
      imgVisible: false,
      imgPathList: [],
      bookInfo: {
        bookName: "",
        integralModelDesc: "",
        paragraphList: [],
      },
    };
  },
  computed: {
    ...mapState(["scoreMenuList", "userInfo", "isAdmin"]),
  },
  methods: {
    toBack() {
      this.$router.push({
        path: "/common/service-manual",
      });
    },
    showImg(url, paraAttaches) {
      this.imgShowClick(
        url,
        paraAttaches?.map((u) => u.url)
      );
    },
    imgShowClick(imgSrc, imgList) {
      const imgListFlag = imgList instanceof Array && imgList.length;
      if (imgSrc) {
        if (imgListFlag) {
          this.imgPathList = imgList;
        } else {
          this.imgPathList = [];
          this.imgPathList.push(imgSrc);
        }
        this.imgVisible = true;
      } else if (imgListFlag) {
        this.imgPathList = imgList;
        this.imgVisible = true;
      } else {
        this.$message.info("当前没有可预览的图片");
      }
    },
    getBookInfo(bookCode) {
      this.$axios
        .post(
          "/handbook/getHandBookInfoDetail",
          this.$qs.stringify({
            schoolCode: this.userInfo.schoolCode,
            bookCode,
          })
        )
        .then(({ data }) => {
          this.bookInfo.id = data.id;
          this.bookInfo.bookCode = data.bookCode;
          this.bookInfo.bookName = data.bookName;
          this.bookInfo.integralModelDesc = data.integralModelDesc;
          this.bookInfo.paragraphList = data.paragraphList;
        });
    },
  },
  created() {
    this.getBookInfo(this.$route.query.bookCode);
  },
};
</script>

<style  lang="less" scoped>
.file-man {
  padding: 30px;
  .el-button {
    background: @theme-color;
    color: #fff;
    font-size: 14px;
  }
  .contain {
    font-size: 24px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .module {
    font-size: 18px;
    font-weight: bold;
    line-height: 24px;
    margin-bottom: 10px;
  }
  .list {
    background-color: #fff;
    border-radius: 20px;
    padding: 20px;
    .list-item {
      margin-bottom: 30px;
      border: 1px solid #e6e6e6;
      border-radius: 20px;
      padding: 40px;
      background-color: aliceblue;
    }
    .title {
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      margin-bottom: 20px;
    }
    .attach {
      display: flex;
      flex-wrap: wrap;
      > div {
        margin: 20px;
      }
    }
    .content {
      font-size: 14px;
      line-height: 24px;
      word-break: break-all;
    }
  }
}
</style>